import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowTotalDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 7,
	viewBox: "0 0 12 7",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.57172 6.82461L0.177143 1.42824C-0.0590476 1.19145 -0.0590476 0.807815 0.177143 0.570428C0.413335 0.333639 0.79697 0.333639 1.03316 0.570428L5.9997 5.53877L10.9662 0.571026C11.2024 0.334237 11.5861 0.334237 11.8229 0.571026C12.059 0.807816 12.059 1.19205 11.8229 1.42884L6.42833 6.82521C6.19458 7.05836 5.80492 7.05836 5.57172 6.82461Z",
		fill: "currentColor"
	})
});
export default SvgArrowTotalDown;
